var _style, _circle, _polyline, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "success",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .path {\n        stroke-dasharray: 10000;\n        stroke-dashoffset: 0;\n      }\n      .path.circle {\n        stroke-dashoffset: 10000;\n        -webkit-animation: dash 0.75s 0.5s ease-in-out forwards;\n        animation: dash 0.75s 0.5s ease-in-out forwards;\n      }\n      .path.line {\n        stroke-dasharray: 10000 10000;\n        stroke-dashoffset: 10000;\n        -webkit-animation: dash-line 0.35s 1.25s ease-in-out forwards;\n        animation: dash-line 0.35s 1.25s ease-in-out forwards;\n      }\n      .path.check {\n        stroke-dashoffset: -10000;\n        -webkit-animation: dash-check 0.5s 0.75s ease-in-out forwards;\n        animation: dash-check 0.5s 0.75s ease-in-out forwards;\n      }\n\n      @-webkit-keyframes dash {\n        0% {\n        stroke-dashoffset: 10000;\n        }\n        100% {\n        stroke-dashoffset: 0;\n        }\n      }\n      @keyframes dash {\n        0% {\n          stroke-dashoffset: 10000;\n        }\n        100% {\n          stroke-dashoffset: 0;\n        }\n      }\n\n\n      @-webkit-keyframes dash-line {\n        0% {\n          stroke-dashoffset: 10000;\n        }\n        100% {\n          stroke-dashoffset: -10000;\n        }\n      }\n      @keyframes dash-line {\n        0% {\n          stroke-dashoffset: 10000;\n        }\n        100% {\n          stroke-dashoffset: -10000;\n        }\n      }\n\n      @-webkit-keyframes dash-check {\n        0% {\n          stroke-dashoffset: -10000;\n        }\n        100% {\n          stroke-dashoffset: 0;\n        }\n      }\n      @keyframes dash-check {\n        0% {\n          stroke-dashoffset: -10000;\n        }\n        100% {\n          stroke-dashoffset: 0;\n        }\n      }\n    ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path circle",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    cx: 100,
    cy: 100,
    r: 50,
    pathLength: 10000
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    transform: "rotate(45,110,95)",
    className: "path check",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "115,70 115,130 85,130 ",
    pathLength: 9999
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(0,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(45,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(90,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(135,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(180,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-135,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-90,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-45,100,100)",
    className: "path line",
    fill: "none",
    stroke: "#73AF55",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100,
    y1: 40,
    x2: 100,
    y2: 10,
    pathLength: 10000
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7c6849d041bd0673f45cdde4d2709e69.svg";
export { ForwardRef as ReactComponent };